export default function AndOrIndentSVG({ className }: { className: string }) {
  return (
    <svg
      width='16'
      height='41'
      viewBox='0 0 16 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 16.5V15.5V0.5H1V15.5H16V16.5H1V40.5H0V16.5Z'
        fill='#ADADAD'
      />
    </svg>
  );
}
